import { gql } from '@apollo/client';

export const RevokeTokenMutation = gql`
    mutation RevokeToken($refreshToken: String!) {
        revokeToken(refreshToken: $refreshToken)
    }
`;
